










































import { Component, Mixins, Prop } from 'vue-property-decorator';
import APP_UTILITIES from '@/utilities/commonFunctions';


import { CatalogSession, SessionBillingCycle } from '@/Model/sessions/catalogTypes';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { ScreenText } from '@/lang/ScreenText';
import { getInstallmentsWithMakeupOnFinalInstallment } from '@/services/checkout/cart/helpers';

@Component
export default class SessionPriceTag extends Mixins(DeviceWidthCheckerMixin) {
  @Prop({ type: Object, required: true }) readonly session!: CatalogSession;
  @Prop({ type: Number, default: 1, required: false }) readonly quantity!: number;

  readonly screenText = new ScreenText();

  get isRecurringPayment(): boolean {
    return [SessionBillingCycle.Weekly, SessionBillingCycle.Monthly].includes(this.session.sessionBillingCycle);
  }

  get formattedPrice(): string {
    const priceValue = ((this.isRecurringPayment)
      ? getInstallmentsWithMakeupOnFinalInstallment(this.session.price, this.session.billingCycleCount)[0] * this.quantity
      : this.session.price * this.quantity
    );

    let formattedPrice = APP_UTILITIES.currencyFmt.format(priceValue);
    if (this.isRecurringPayment) {
      let intervalAbbr = '';
      if (this.session.sessionBillingCycle === SessionBillingCycle.Weekly) {
        intervalAbbr = this.screenText.getScreenText('PRICE_RECURRING_WEEKLY_ABBREVIATION');
      }
      else if (this.session.sessionBillingCycle === SessionBillingCycle.Monthly) {
        intervalAbbr = this.screenText.getScreenText('PRICE_RECURRING_MONTHLY_ABBREVIATION');
      }
      formattedPrice += `/${intervalAbbr}`;
    }
    return formattedPrice;
  }

  get formattedPerChildText(): string {
    const sessionPrice = APP_UTILITIES.currencyFmt.format(this.session.price);
    const perChildText = this.screenText.getScreenText('CHECKOUT_PER_CHILD');
    return `${sessionPrice} ${perChildText}`;
  }

  get tooltipText(): string {
    let text = '';
    if (this.session.price === 0) {
      text = this.screenText.getScreenText('PRICE_TOOLTIP_FREE');
    }
    else if (this.isRecurringPayment) {
      text = this.screenText.getScreenText('PRICE_TOOLTIP_RECURRING');
    }
    return text;
  }

  get recurringTotalText(): string {
    const totalAmount = this.session.price * this.quantity;
    const formattedTotalAmount = APP_UTILITIES.currencyFmt.format(totalAmount);
    return `${formattedTotalAmount} ${this.screenText.getScreenText('PRICE_RECURRING_TOTAL')}`;
  }

  get recurringPaymentCountText(): string {
    return `${this.session.billingCycleCount} ${this.screenText.getScreenText('PRICE_RECURRING_PAYMENTS')}`;
  }
}

